import { Box, Container, Stack } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PageNavigationCard from '../common/PageNavigationCard';
import { PageDetails } from './config';
import PortalPageHeader from '../common/PortalPageHeader';
import { isUserAdvisor, getUser } from '../Layout/utils';

export default function Systems() {
  const id = PageDetails.systems.id;
  const [pageDetails, setPageDetails] = useState({});
  const [systemPages, setSystemPages] = useState([]);

  const user = useSelector((state) => state.AWSReducer.user);
  const impersonation = useSelector((state) => state.impersonationReducer.impersonation);
  const preferences = useSelector((state) => state.preferencesReducer.preferences);

  const currentUser = getUser(user, impersonation);
  const emailService = preferences?.DisplayOptions?.Options?.EmailService;

  useEffect(() => {
    const details = PageDetails[id];
    setPageDetails(details);

    const pages = { ...PageDetails };
    delete pages[id];

    const allPages = Object.values(pages).filter((page) => {
      if (!page.visibleTo) return true;
      if (page.visibleTo === PageDetails.advisor.id) return isUserAdvisor(currentUser);
      if (page.visibleTo === PageDetails.gmail.id)
        return ['both', PageDetails.gmail.id].includes(emailService);
      if (page.visibleTo === PageDetails.outlook.id) return emailService !== PageDetails.gmail.id;
      return true;
    });

    setSystemPages(allPages);
  }, [currentUser, emailService]);

  return (
    <React.Fragment>
      {Object.values(pageDetails).length > 0 && (
        <Container id={`${id}__container_pageWrapper`} className="myOdu__container secondaryPage">
          <PortalPageHeader
            title={pageDetails?.title}
            id={id}
            breadcrumbs={pageDetails?.breadcrumbs}
          />

          <Box id={`${id}__box_wrapper`}>
            <Stack
              id={`${id}__row_systemsOptions`}
              direction={{ xs: 'column', lg: 'row' }}
              spacing={2}
              alignItems={'stretch'}
              flexWrap="wrap"
              useFlexGap
            >
              {systemPages.map((item) => (
                <PageNavigationCard
                  key={item.id}
                  url={pageDetails.url}
                  id={id}
                  subPage={item}
                  header={'h4'}
                />
              ))}
            </Stack>
          </Box>
        </Container>
      )}
    </React.Fragment>
  );
}
